/**
 * 🏷️ Card Tags Service
 * 
 * Serviço para gerenciar tags dos cards via API
 */

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

class CardTagsService {
  /**
   * Obter token do localStorage
   */
  getAuthToken() {
    return localStorage.getItem('token');
  }

  /**
   * Headers padrão com autenticação
   */
  getHeaders() {
    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.getAuthToken()}`
    };
  }

  /**
   * Obter todas as tags do produtor
   */
  async getProducerTags() {
    try {
      const response = await fetch(`${API_URL}/api/card-tags`, {
        headers: this.getHeaders()
      });

      if (!response.ok) {
        throw new Error('Erro ao buscar tags do produtor');
      }

      return await response.json();
    } catch (error) {
      console.error('Erro ao buscar tags:', error);
      throw error;
    }
  }

  /**
   * Criar nova tag
   */
  async createTag(name, color) {
    try {
      const response = await fetch(`${API_URL}/api/card-tags`, {
        method: 'POST',
        headers: this.getHeaders(),
        body: JSON.stringify({ name, color })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao criar tag');
      }

      return await response.json();
    } catch (error) {
      console.error('Erro ao criar tag:', error);
      throw error;
    }
  }

  /**
   * Deletar tag
   */
  async deleteTag(tagId) {
    try {
      const response = await fetch(`${API_URL}/api/card-tags/${tagId}`, {
        method: 'DELETE',
        headers: this.getHeaders()
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao deletar tag');
      }

      return await response.json();
    } catch (error) {
      console.error('Erro ao deletar tag:', error);
      throw error;
    }
  }

  /**
   * Obter tags de um card específico
   */
  async getCardTags(saleId) {
    try {
      const response = await fetch(`${API_URL}/api/card-tags/card/${saleId}`, {
        headers: this.getHeaders()
      });

      if (!response.ok) {
        throw new Error('Erro ao buscar tags do card');
      }

      return await response.json();
    } catch (error) {
      console.error('Erro ao buscar tags do card:', error);
      throw error;
    }
  }

  /**
   * Associar tag a um card
   */
  async addTagToCard(saleId, tagId) {
    try {
      const response = await fetch(`${API_URL}/api/card-tags/card/${saleId}`, {
        method: 'POST',
        headers: this.getHeaders(),
        body: JSON.stringify({ tagId })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao associar tag ao card');
      }

      return await response.json();
    } catch (error) {
      console.error('Erro ao associar tag:', error);
      throw error;
    }
  }

  /**
   * Remover tag de um card
   */
  async removeTagFromCard(saleId, tagId) {
    try {
      const response = await fetch(`${API_URL}/api/card-tags/card/${saleId}/${tagId}`, {
        method: 'DELETE',
        headers: this.getHeaders()
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao remover tag do card');
      }

      return await response.json();
    } catch (error) {
      console.error('Erro ao remover tag:', error);
      throw error;
    }
  }

  /**
   * Paleta de cores predefinidas com nomes
   */
  getColorPalette() {
    return [
      { name: 'Roxo', value: '#6366F1' },
      { name: 'Rosa', value: '#EC4899' },
      { name: 'Azul', value: '#3B82F6' },
      { name: 'Verde', value: '#10B981' },
      { name: 'Amarelo', value: '#F59E0B' },
      { name: 'Vermelho', value: '#EF4444' },
      { name: 'Ciano', value: '#06B6D4' },
      { name: 'Laranja', value: '#F97316' },
      { name: 'Lima', value: '#84CC16' },
      { name: 'Índigo', value: '#4F46E5' },
      { name: 'Fúcsia', value: '#D946EF' },
      { name: 'Cinza', value: '#6B7280' }
    ];
  }
}

export default new CardTagsService();
